import { render, staticRenderFns } from "./SeparateProducts.vue?vue&type=template&id=62483b40&scoped=true"
import script from "./SeparateProducts.vue?vue&type=script&lang=js"
export * from "./SeparateProducts.vue?vue&type=script&lang=js"
import style0 from "./SeparateProducts.vue?vue&type=style&index=0&id=62483b40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62483b40",
  null
  
)

export default component.exports